import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
// id -> name map of staff/admin users (fetched once per session)
export function useStaffNames() {
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!cache) cache = api.get("/staff").then((r) => Object.fromEntries((r.data || []).map((s) => [s.id, s.name]))).catch(() => { cache = null; return {}; });
    cache.then(setMap);
  }, []);
  return map;
}
